module.exports = __webpack_public_path__ + "media/images/LabTestsLogo-3bf9bf61839cd0c785b9170213ceb147.png";